var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 19.3333C12.0958 19.3333 14.0238 18.634 15.5818 17.4673L24.6665 26.5527L26.5518 24.6667L17.4672 15.582C18.6338 14.024 19.3332 12.096 19.3332 10C19.3332 4.84534 15.1545 0.666672 9.99984 0.666672C4.84517 0.666672 0.666504 4.84534 0.666504 10C0.666504 15.1547 4.84517 19.3333 9.99984 19.3333ZM9.99984 3.33334C13.6758 3.33334 16.6665 6.32401 16.6665 10C16.6665 13.676 13.6758 16.6667 9.99984 16.6667C6.32384 16.6667 3.33317 13.676 3.33317 10C3.33317 6.32401 6.32384 3.33334 9.99984 3.33334Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a7dc118d649227075398990a8a986a5a.svg";
export { ForwardRef as ReactComponent };